import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ApiResListsType, OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import { ModuleType } from 'global-services/constants/OhsObject';

import { OhsSysFieldDefinition } from './OhsSysFieldModel';
import { OhsCusval } from '../cusvals/OhsCusvalModel';
import { formatSysFieldDefToCusval } from './sysFieldUtils';

export const fetchSysFieldDefinition = async (
  _id: string
): Promise<OhsSysFieldDefinition | null> => {
  const res: OhsSysFieldDefinition | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.SysField,
    OhsApiRequestName.Fetch,
    {
      forType: ModuleType.Injury,
      _id,
    }
  );
  return res || null;
};

export const fetchSysFieldCusvalFormat = async (_id: string): Promise<OhsCusval | null> => {
  const res: OhsSysFieldDefinition | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.SysField,
    OhsApiRequestName.Fetch,
    {
      forType: ModuleType.Injury,
      _id,
    }
  );
  if (res) return formatSysFieldDefToCusval(res);
  return res;
};

export const fetchBulkSysFieldCusvalFormat = async (_ids: string[]): Promise<OhsCusval[]> => {
  const res: OhsSysFieldDefinition[] | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.SysField,
    OhsApiRequestName.Fetch,
    {
      forType: ModuleType.Injury,
      _ids,
    }
  );
  const newSysFieldCusvals = (res || [])?.map((item) => formatSysFieldDefToCusval(item));

  return newSysFieldCusvals;
};

// TODO - improve, currently just a fixed filter
export const fetchSysFieldList = async () => {
  const res: ApiResListsType<any[]> | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.SysField,
    OhsApiRequestName.List,
    {
      forType: ModuleType.Injury,
      filter: {
        viewPreset: 'view_1',
        count: false,
        archived: false,
        // fieldTypes: ['linked_value'],
        sort: {
          order: -1,
          key: '_id',
        },
      },
    }
  );
  return res?.items;
};

// TODO - improve, currently just a fixed filter
export const fetchSysFieldCusvalFormatList = async (): Promise<OhsCusval[] | null> => {
  const res: ApiResListsType<OhsSysFieldDefinition[]> | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.SysField,
    OhsApiRequestName.List,
    {
      forType: ModuleType.Injury,
      filter: {
        viewPreset: 'view_1',
        count: false,
        archived: false,
        // fieldTypes: ['linked_value'],
        sort: {
          order: -1,
          key: '_id',
        },
      },
    }
  );
  return res ? res?.items.map((item) => formatSysFieldDefToCusval(item)) : null;
};

// TODO - use the dedicated bulk fetch once available
export const fakeFetchBulkSysFieldCusvalFormat = async (_ids: string[]): Promise<OhsCusval[]> => {
  const resList = _ids.map((id) => fetchSysFieldCusvalFormat(id));
  const result = await Promise.all(resList);

  return result.filter((item) => item !== null);
};
